'use client'

import { Skeleton } from '@morpho-org/ui-v6/server'

const VaultRatingsLoading = () => {
  return <Skeleton className="h-[96px] w-[299px] rounded-[20px] max-md:min-w-full" />
}

export default VaultRatingsLoading
